// A customer review on the evergreen card: five stars, an optional
// headline beside them, the quote in serif, and who said it. Children
// render beneath the attribution for anything a host adds under the
// review (the quote screen's reassurance points).

import type { ReactNode } from "react";

export default function ReviewCard({
  headline,
  quote,
  attribution,
  children,
}: {
  headline?: string;
  quote: string;
  attribution: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-4 rounded-xl bg-evergreen px-5 py-6 sm:px-7">
      <div className="flex flex-wrap items-center gap-3">
        <div
          aria-hidden="true"
          className="flex gap-0.5 text-[19px] leading-none text-daisy"
        >
          {"★★★★★"}
        </div>
        {headline && (
          <span className="text-base font-bold text-ivory-light">
            {headline}
          </span>
        )}
      </div>
      <p className="font-serif text-[22px] leading-[1.35] text-ivory-light">
        &ldquo;{quote}&rdquo;
      </p>
      <span className="text-base text-oat">{attribution}</span>
      {children}
    </div>
  );
}
